import { useMutation, useQueryClient } from 'react-query'
import {
  attachCard,
  buyCourse,
  buySubscription,
  deletePaymentMethod,
  setMainPaymentMethod,
} from '../api/paymentsApi'
import type {
  AttachCardPayload,
  BuyCoursePayload,
  BuySubscriptionPayload,
  InvoiceResponse,
} from '../api/types'
import { PAYMENT_METHODS_QUERY_KEY } from './usePaymentMethodsQuery'

export const useBuySubscriptionMutation = () => {
  return useMutation<InvoiceResponse, Error, BuySubscriptionPayload>(buySubscription)
}

export const useBuyCourseMutation = () => {
  return useMutation<InvoiceResponse, Error, BuyCoursePayload>(buyCourse)
}

export const useAttachCardMutation = () => {
  return useMutation<InvoiceResponse, Error, AttachCardPayload>(attachCard)
}

export const useDeletePaymentMethodMutation = () => {
  const qc = useQueryClient()
  return useMutation<void, Error, number>(deletePaymentMethod, {
    onSuccess: () => qc.invalidateQueries(PAYMENT_METHODS_QUERY_KEY),
  })
}

export const useSetMainPaymentMethodMutation = () => {
  const qc = useQueryClient()
  return useMutation<void, Error, number>(setMainPaymentMethod, {
    onSuccess: () => qc.invalidateQueries(PAYMENT_METHODS_QUERY_KEY),
  })
}
